module.exports = __webpack_public_path__ + "img/item3.a2fce6e2.png";